if (!customElements.get('media-tab')) {
  class MediaTab extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tabsInitialized === 'true') return;

      const tabWrapper = this.querySelector('.our_journey_tab');
      if (!tabWrapper) return;

      const tabs = [...tabWrapper.querySelectorAll('.tabs_menu [role="tab"]')];
      const tabPanels = [...tabWrapper.querySelectorAll('.our_journey_content > [role="tabpanel"]')];
      const tabImages = [...this.querySelectorAll('.our_journey_images')];

      if (!tabs.length || !tabPanels.length) return;

      this.dataset.tabsInitialized = 'true';

      const activateTab = (tabIndex) => {
        if (tabIndex < 0 || tabIndex >= tabs.length) return;

        tabs.forEach((tab, index) => {
          const isActive = index === tabIndex;

          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        tabPanels.forEach((panel, index) => {
          const isActive = index === tabIndex;

          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        });

        tabImages.forEach((image, index) => {
          const isActive = index === tabIndex;

          image.hidden = !isActive;
          image.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index));
        tab.addEventListener('shopify:block:select', () => activateTab(index));

        tab.addEventListener('keydown', (event) => {
          let nextIndex;

          switch (event.key) {
            case 'ArrowRight':
              nextIndex = (index + 1) % tabs.length;
              break;
            case 'ArrowLeft':
              nextIndex = (index - 1 + tabs.length) % tabs.length;
              break;
            case 'Home':
              nextIndex = 0;
              break;
            case 'End':
              nextIndex = tabs.length - 1;
              break;
            case 'Enter':
            case ' ':
              event.preventDefault();
              activateTab(index);
              return;
            default:
              return;
          }

          event.preventDefault();
          activateTab(nextIndex);
          tabs[nextIndex].focus();
        });
      });

      const activeTabIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      activateTab(activeTabIndex >= 0 ? activeTabIndex : 0);
    }
  }

  customElements.define('media-tab', MediaTab);
}
